import { render, staticRenderFns } from "./VueAudio.vue?vue&type=template&id=1c0280c0&scoped=true"
import script from "./vueaudio.plugin.js?vue&type=script&lang=js&external"
export * from "./vueaudio.plugin.js?vue&type=script&lang=js&external"
import style0 from "./VueAudio.vue?vue&type=style&index=0&id=1c0280c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0280c0",
  null
  
)

export default component.exports